<div class="chat-page">
  <app-wrapper-chat
    *ngIf="activeTab === 'help'; else priceActionChat"
    agentName="Sahay"
    agentFilePath="help_agent/help_agent_cli.py"
    greeting="How can I help you?">
  </app-wrapper-chat>

  <ng-template #priceActionChat>
    <app-wrapper-chat
      agentName="Chat"
      agentFilePath="chat_agent/chat_agent_cli.py"
      greeting="Which action do u need help with?">
    </app-wrapper-chat>
  </ng-template>
</div>
